// Pages locales "service + ville" (référencement Google sur Lille).
// Même règle que servicesData.js : aucun engagement inventé, uniquement ce que l'offre contient.
// Affichées par MetierPage.jsx (même mise en page que les pages métier).
// Pour ajouter une page : une entrée ici + son slug dans LOCAL_ORDER, puis `node scripts/gen-seo.mjs`.

export const LOCAL_PAGES = {
  "depannage-informatique-lille": {
    navLabel: "Dépannage informatique à Lille",
    serviceType: "Dépannage informatique",
    phoneCta: true,
    seoTitle: "Dépannage informatique à Lille pour les entreprises",
    seoDescription:
      "Dépannage informatique à Lille pour les entreprises : ordinateur en panne, messagerie, réseau, wifi, imprimante, virus. Intervention à distance ou sur site. 03 20 49 02 04.",
    kicker: "Dépannage informatique · Lille",
    title: "Un poste bloqué, un réseau en panne ? Appelez, on s'en occupe.",
    intro:
      "Umbo dépanne l'informatique des entreprises de Lille et de la métropole : ordinateurs, messagerie, réseau, wifi, imprimantes, virus. La plupart des pannes se règlent à distance, et nous nous déplaçons quand c'est nécessaire.",
    sections: [
      {
        heading: "Les pannes que nous réglons",
        blocks: [
          { title: "Un ordinateur qui ne démarre plus ou qui rame", text: "Écran noir, démarrage interminable, plantages à répétition, disque saturé : nous trouvons la cause et remettons le poste en état, ou nous vous disons franchement s'il faut le remplacer." },
          { title: "La messagerie qui ne fonctionne plus", text: "Emails qui n'arrivent plus, boîte pleine, mot de passe perdu, messagerie impossible à configurer sur un nouveau poste ou un téléphone." },
          { title: "Internet, wifi et réseau", text: "Plus de connexion, wifi instable, un poste qui ne voit plus le dossier partagé ou le serveur : nous remettons le réseau d'aplomb." },
          { title: "L'imprimante ou le scanner introuvable", text: "L'imprimante réseau qui disparaît, le scanner qui n'envoie plus vers la messagerie : le genre de panne qui fait perdre une matinée à toute une équipe." },
          { title: "Un virus ou un email piégé", text: "Quelqu'un a cliqué sur une pièce jointe suspecte, le poste se comporte bizarrement, des messages partent tout seuls : nous isolons le poste, faisons le point et nettoyons." },
          { title: "Un nouveau poste à installer", text: "Un ordinateur neuf à configurer, les données à transférer depuis l'ancien, la messagerie et les imprimantes à reconnecter." },
        ],
      },
      {
        heading: "Comment se passe un dépannage",
        paragraphs: [
          "Vous nous appelez au 03 20 49 02 04 ou vous nous écrivez. Nous faisons le point avec vous au téléphone pour comprendre ce qui se passe.",
          "Dans la plupart des cas, nous prenons la main à distance sur l'ordinateur concerné, avec votre accord, et la panne est réglée sans que personne n'ait à se déplacer.",
          "Si le problème est matériel ou ne peut pas se régler à distance, nous intervenons sur place, dans vos locaux à Lille ou dans la métropole. Avant toute intervention, nous vous expliquons ce que nous allons faire.",
        ],
      },
      {
        heading: "Client ou non, nous vous dépannons",
        paragraphs: [
          "Vous n'avez pas besoin d'être client pour nous appeler : nous dépannons aussi les entreprises qui ont simplement besoin d'un coup de main ponctuel.",
          "Nos clients sous contrat, eux, n'ont plus à se poser la question : le dépannage est compris. Support illimité par téléphone et à distance du lundi au vendredi de 8h à 18h, intervention sous 4 heures ouvrées, et sous 2 heures si l'activité est complètement à l'arrêt.",
        ],
      },
      {
        heading: "Et pour que la panne ne revienne pas",
        paragraphs: [
          "Une panne qui revient, c'est souvent un parc que personne ne suit : mises à jour en retard, disque qui fatigue, sauvegarde qui s'est arrêtée sans que personne ne s'en aperçoive.",
          "C'est pour cela que nous proposons aussi la maintenance informatique : nous surveillons vos postes 24h/24, nous les entretenons, et nous intervenons souvent avant que vous ne remarquiez le problème. Moins de dépannages, et moins de mauvaises surprises.",
        ],
      },
    ],
    faq: [
      {
        q: "Faut-il être client pour être dépanné ?",
        a: "Non. Nous dépannons aussi les entreprises qui ne sont pas sous contrat avec nous, pour une intervention ponctuelle.",
      },
      {
        q: "Pouvez-vous intervenir à distance ?",
        a: "Oui, et c'est le cas pour la plupart des pannes. Nous prenons la main sur l'ordinateur concerné, uniquement avec votre accord, et vous voyez ce que nous faisons à l'écran.",
      },
      {
        q: "Vous déplacez-vous dans nos locaux ?",
        a: "Oui, quand la panne ne peut pas se régler à distance : à Lille et dans toute la métropole lilloise, notamment Roubaix, Tourcoing, Villeneuve-d'Ascq, Marcq-en-Barœul, Lambersart et La Madeleine.",
      },
      {
        q: "Combien coûte un dépannage ponctuel ?",
        a: "Le tarif dépend de la panne et du mode d'intervention, à distance ou sur place. Nous vous l'indiquons avant de commencer. Pour nos clients sous contrat, le dépannage est compris dans l'abonnement.",
      },
      {
        q: "Un salarié a cliqué sur un email suspect. Que faire ?",
        a: "Appelez-nous sans attendre et, si possible, débranchez le poste du réseau (câble et wifi) sans l'éteindre. Nous vérifions ce qui s'est passé et ce qui a pu être touché.",
      },
    ],
  },

  "maintenance-informatique-lille": {
    navLabel: "Maintenance informatique à Lille",
    serviceType: "Maintenance informatique",
    phoneCta: true,
    seoTitle: "Maintenance informatique à Lille pour les TPE",
    seoDescription:
      "Maintenance informatique à Lille pour les TPE : support illimité, surveillance 24h/24, intervention sous 4 h ouvrées, 2 visites sur site par an et matériel défectueux remplacé.",
    kicker: "Maintenance informatique · Lille",
    title: "Votre parc entretenu, surveillé et réparé, sans que vous ayez à y penser.",
    intro:
      "Umbo assure la maintenance informatique des petites entreprises de Lille et de la métropole : support illimité, surveillance permanente, entretien des postes et interventions sur site, avec un seul interlocuteur qui connaît votre installation.",
    sections: [
      {
        heading: "Pourquoi un contrat de maintenance",
        paragraphs: [
          "Dans une entreprise de quelques personnes, l'informatique n'appartient à personne. On s'en occupe entre deux rendez-vous, et quand plus rien ne marche, on cherche le numéro du dépanneur venu l'an dernier.",
          "Le résultat, ce sont des pannes qui reviennent, des mises à jour jamais faites et une sauvegarde dont personne ne sait si elle fonctionne. Un contrat de maintenance inverse la logique : au lieu de réparer quand ça casse, quelqu'un entretient votre parc en continu et intervient avant que la panne ne vous arrête.",
        ],
      },
      {
        heading: "Ce que comprend notre maintenance",
        blocks: [
          { title: "Un support illimité", text: "Par téléphone et à distance, du lundi au vendredi de 8h à 18h, sans compter les appels. En face, une équipe qui connaît déjà votre installation." },
          { title: "Une surveillance 24h/24, 7j/7", text: "Nous surveillons vos postes en permanence pour repérer et traiter de nombreux problèmes avant qu'ils ne perturbent votre activité." },
          { title: "Un délai d'intervention écrit", text: "Sous 4 heures ouvrées, et sous 2 heures si votre activité est complètement à l'arrêt. Ce sont nos engagements, écrits noir sur blanc dans le contrat." },
          { title: "Deux visites sur site par an", text: "En plus du support à distance, deux interventions dans vos locaux sont incluses chaque année." },
          { title: "Le matériel défectueux remplacé", text: "Le remplacement du matériel défectueux est pris en charge : une panne matérielle ne devient pas un budget imprévu." },
          { title: "Des sauvegardes vraiment vérifiées", text: "Vos ordinateurs et votre messagerie sont sauvegardés, et nous testons deux fois par an que vos données peuvent réellement être restaurées." },
          { title: "La sécurité surveillée en permanence", text: "Seuls les logiciels autorisés peuvent s'exécuter sur vos postes, et une équipe de sécurité surveille les alertes 24h/24, 365 jours par an." },
          { title: "Un rapport chaque année", text: "Nous traçons nos interventions et les événements de sécurité. Chaque année, vous recevez un rapport qui les récapitule." },
        ],
      },
      {
        heading: "Une équipe basée à Lille",
        paragraphs: [
          "Nos bureaux sont au 679 avenue de la République, à Lille. Nous intervenons dans toute la métropole lilloise : Roubaix, Tourcoing, Villeneuve-d'Ascq, Marcq-en-Barœul, Lambersart, La Madeleine, et au-delà dans les Hauts-de-France.",
          "La plupart des demandes se règlent à distance, en quelques minutes. Quand il faut venir, nous venons.",
        ],
      },
    ],
    faq: [
      {
        q: "Faut-il changer nos ordinateurs ?",
        a: "Non. Nous prenons en charge et sécurisons votre matériel actuel. Si un poste est trop ancien pour être protégé correctement, nous vous le signalons. Une option permet aussi de renouveler vos ordinateurs tous les trois ans, sans investissement.",
      },
      {
        q: "Y a-t-il un engagement ?",
        a: "Oui, le contrat est conclu pour 3 ans. C'est ce qui nous permet de garantir un prix fixe, tout compris, et d'investir dès le départ dans la mise en place et la sécurisation de votre informatique.",
      },
      {
        q: "Nous avons déjà un prestataire. Comment se passe le changement ?",
        a: "Nous commençons par un état des lieux de votre informatique, puis nous organisons la reprise sans interrompre votre activité.",
      },
      {
        q: "Quelle différence avec un dépannage ponctuel ?",
        a: "Un dépannage règle une panne au moment où elle arrive. La maintenance évite qu'elle arrive : surveillance permanente, entretien, sauvegardes vérifiées, et le dépannage est compris quand il faut intervenir.",
      },
      {
        q: "Intervenez-vous en dehors de Lille ?",
        a: "Oui, dans toute la métropole lilloise et les Hauts-de-France. La plupart des interventions se font à distance, et nous nous déplaçons quand c'est nécessaire.",
      },
    ],
  },
};

// ---------------------------------------------------------------------------
// Pages villes : "Maintenance et dépannage informatique à <ville>".
// Règle anti-doublon : chaque ville a son propre texte (intro, tissu local,
// communes voisines, question de FAQ). Seul le bloc "comment nous travaillons"
// est commun. Ne jamais publier une ville sans texte local réellement écrit.
// Vocabulaire client : "surveillance", "à distance" — jamais de jargon technique.
// ---------------------------------------------------------------------------

const VILLES = {
  roubaix: {
    nom: "Roubaix",
    a: "à Roubaix",
    intro:
      "Umbo assure la maintenance et le dépannage informatique des entreprises de Roubaix : commerces, artisans, cabinets, PME et jeunes entreprises du numérique. Vos postes sont surveillés en permanence et la plupart des pannes se règlent à distance, en quelques minutes.",
    localHeading: "Les entreprises de Roubaix",
    localParagraphs: [
      "Ancienne capitale du textile, Roubaix est devenue une ville de commerce, de vente en ligne et de jeunes entreprises du numérique, à côté des commerces du centre-ville, des artisans et des professions libérales.",
      "Point commun de ces entreprises : elles travaillent avec peu de monde, et un ordinateur en panne ou une messagerie bloquée arrête vite toute l'activité. C'est exactement ce que notre maintenance évite.",
    ],
    voisines: ["Tourcoing", "Wattrelos", "Croix", "Hem", "Lys-lez-Lannoy", "Leers"],
    faqLocal: {
      q: "Nous sommes une entreprise de vente en ligne à Roubaix. Pouvez-vous nous accompagner ?",
      a: "Oui. Nous prenons en charge les postes, la messagerie, le réseau, les sauvegardes et la sécurité de votre équipe. Votre boutique en ligne elle-même reste gérée par sa plateforme ou son agence ; nous nous occupons de tout ce qui permet à vos équipes de travailler.",
    },
  },

  tourcoing: {
    nom: "Tourcoing",
    a: "à Tourcoing",
    intro:
      "Umbo assure la maintenance et le dépannage informatique des entreprises de Tourcoing : PME, commerces, cabinets et studios du numérique. Nous surveillons vos postes en continu et réglons la plupart des pannes à distance, sans attendre un technicien.",
    localHeading: "Les entreprises de Tourcoing",
    localParagraphs: [
      "Entre le centre-ville, la Plaine Images dédiée à l'image et au numérique, et les zones d'activité proches de la frontière belge, Tourcoing réunit des entreprises très différentes, souvent de petite taille.",
      "Studio créatif ou commerce de proximité, le besoin est le même : des ordinateurs qui fonctionnent, des fichiers sauvegardés et quelqu'un qui répond tout de suite en cas de problème.",
    ],
    voisines: ["Roubaix", "Mouvaux", "Neuville-en-Ferrain", "Roncq", "Halluin", "Wattrelos"],
    faqLocal: {
      q: "Nos fichiers sont très volumineux (vidéo, graphisme). Est-ce un problème pour la sauvegarde ?",
      a: "Non, mais cela se prévoit. Lors de l'état des lieux, nous regardons le volume de vos fichiers et la façon dont vous travaillez, pour mettre en place une sauvegarde adaptée et vérifier qu'elle peut réellement être restaurée.",
    },
  },

  "villeneuve-d-ascq": {
    nom: "Villeneuve-d'Ascq",
    a: "à Villeneuve-d'Ascq",
    intro:
      "Umbo assure la maintenance et le dépannage informatique des entreprises de Villeneuve-d'Ascq : bureaux, cabinets, PME du tertiaire et commerces. Vos postes sont surveillés 24h/24 et la plupart des incidents sont réglés à distance.",
    localHeading: "Les entreprises de Villeneuve-d'Ascq",
    localParagraphs: [
      "Avec ses parcs d'activité comme la Haute Borne, son campus universitaire et ses nombreux bureaux, Villeneuve-d'Ascq accueille beaucoup d'entreprises de services : cabinets de conseil, bureaux d'études, agences, professions libérales.",
      "Dans ces métiers, tout passe par l'ordinateur et la messagerie. Une panne, c'est une journée de travail perdue pour toute l'équipe. Notre maintenance vise à ce qu'elle n'arrive pas, et à la régler vite quand elle arrive.",
    ],
    voisines: ["Lezennes", "Mons-en-Barœul", "Hellemmes", "Croix", "Lesquin", "Sainghin-en-Mélantois"],
    faqLocal: {
      q: "Nous partageons des bureaux ou un réseau avec d'autres entreprises. Pouvez-vous sécuriser notre poste de travail quand même ?",
      a: "Oui. Nous sécurisons vos postes et vos accès indépendamment du réseau du bâtiment : seuls les logiciels autorisés peuvent s'exécuter, et vos comptes sont protégés même si le réseau partagé ne l'est pas.",
    },
  },

  "marcq-en-baroeul": {
    nom: "Marcq-en-Barœul",
    a: "à Marcq-en-Barœul",
    intro:
      "Umbo assure la maintenance et le dépannage informatique des entreprises et professions libérales de Marcq-en-Barœul. Nous surveillons vos postes en permanence et réglons la plupart des pannes à distance, pour que votre cabinet ou votre bureau ne s'arrête pas.",
    localHeading: "Les entreprises de Marcq-en-Barœul",
    localParagraphs: [
      "Le long du Grand Boulevard et dans le centre, Marcq-en-Barœul compte de nombreux bureaux, cabinets et professions libérales : avocats, experts-comptables, agences immobilières, cabinets de santé, sociétés de conseil.",
      "Ces métiers manipulent des données confidentielles au quotidien. En plus de la maintenance, ils ont besoin d'une sécurité sérieuse et de sauvegardes vérifiées : c'est compris dans notre offre, sans formule au rabais.",
    ],
    voisines: ["La Madeleine", "Mouvaux", "Bondues", "Wasquehal", "Croix", "Marquette-lez-Lille"],
    faqLocal: {
      q: "Nous sommes un cabinet avec des données confidentielles. Que fait Umbo pour les protéger ?",
      a: "Seuls les logiciels autorisés peuvent s'exécuter sur vos postes, votre messagerie est filtrée, chaque personne reçoit deux clés de sécurité physiques, et une équipe surveille les alertes 24h/24. Chaque année, un rapport récapitule les interventions et les événements de sécurité, une trace utile au titre du RGPD.",
    },
  },

  wattrelos: {
    nom: "Wattrelos",
    a: "à Wattrelos",
    intro:
      "Umbo assure la maintenance et le dépannage informatique des entreprises de Wattrelos : artisans, commerces, PME et entreprises de services. Vos postes sont surveillés en continu, et la plupart des pannes sont réglées à distance, dès votre appel.",
    localHeading: "Les entreprises de Wattrelos",
    localParagraphs: [
      "Ville frontalière avec la Belgique, Wattrelos compte de nombreuses PME, artisans et entreprises de services, installés dans ses zones d'activité ou en centre-ville.",
      "Dans ces entreprises, il n'y a généralement personne pour s'occuper de l'informatique. Le dirigeant le fait entre deux chantiers ou deux clients. Notre rôle est de lui retirer complètement ce sujet.",
    ],
    voisines: ["Roubaix", "Tourcoing", "Leers", "Lys-lez-Lannoy", "Hem"],
    faqLocal: {
      q: "Nous sommes une petite équipe, souvent sur le terrain. Comment se passe le support ?",
      a: "Vous appelez un seul numéro, nous prenons la main à distance sur l'ordinateur concerné, avec votre accord. Pas besoin d'être présent au bureau ni d'attendre un passage de technicien pour la plupart des problèmes.",
    },
  },

  lambersart: {
    nom: "Lambersart",
    a: "à Lambersart",
    intro:
      "Umbo assure la maintenance et le dépannage informatique des entreprises et professions libérales de Lambersart. Nous surveillons vos postes en permanence et réglons la plupart des pannes à distance, en quelques minutes.",
    localHeading: "Les entreprises de Lambersart",
    localParagraphs: [
      "À Lambersart, l'activité économique est faite surtout de commerces, de professions libérales et de petites entreprises de services : cabinets médicaux et paramédicaux, avocats, architectes, agences, indépendants.",
      "Ce sont des structures de quelques personnes, sans service informatique, où chaque panne retombe sur le dirigeant. Avec Umbo, il a un seul numéro à appeler, et une équipe qui connaît déjà son installation.",
    ],
    voisines: ["Lille", "Saint-André-lez-Lille", "Lomme", "Marquette-lez-Lille", "Verlinghem"],
    faqLocal: {
      q: "Je suis seul ou à deux au cabinet. Une offre de maintenance a-t-elle un sens pour moi ?",
      a: "Oui. Quand vous êtes seul ou à deux, une panne ou un piratage arrête toute l'activité : la surveillance, les sauvegardes vérifiées et le support compris sont justement faits pour ça. Lors de l'échange gratuit, nous regardons ensemble la formule adaptée à la taille de votre cabinet.",
    },
  },
};

// Bloc commun : notre façon de travailler (vraie pour toutes les villes).
const commentNousTravaillons = (v) => ({
  heading: "Comment nous travaillons",
  blocks: [
    { title: "La panne évitée plutôt que réparée", text: "Nos outils surveillent vos postes en permanence : disque qui fatigue, mises à jour en retard, sauvegarde arrêtée. Nous intervenons avant que le problème ne vous bloque, souvent sans que vous ne le remarquiez." },
    { title: "Un dépannage immédiat, à distance", text: `Quand quelque chose ne va pas, vous appelez un seul numéro. Nous prenons la main à distance sur l'ordinateur concerné, avec votre accord, et la plupart des pannes sont réglées en quelques minutes. Pas besoin d'attendre qu'un technicien se déplace ${v.a}.` },
    { title: "Un délai d'intervention écrit", text: "Support illimité du lundi au vendredi de 8h à 18h, intervention sous 4 heures ouvrées, et sous 2 heures si votre activité est complètement à l'arrêt." },
    { title: "Sur place quand c'est indispensable", text: "Matériel à remplacer, branchement à refaire : quand une présence est vraiment nécessaire, nous venons dans vos locaux. Deux interventions sur site sont incluses chaque année." },
  ],
});

const liensUtiles = {
  heading: "À voir aussi",
  links: [
    { to: "/informatique-hauts-de-france", label: "Toutes les villes où nous intervenons" },
    { to: "/maintenance-informatique-lille", label: "Maintenance informatique à Lille" },
    { to: "/depannage-informatique-lille", label: "Dépannage informatique à Lille" },
  ],
};

const villePage = (v) => ({
  navLabel: `Informatique ${v.a}`,
  serviceType: "Maintenance et dépannage informatique",
  areaServed: { "@type": "City", name: v.nom },
  phoneCta: true,
  seoTitle: `Maintenance et dépannage informatique ${v.a}`,
  seoDescription: `Maintenance et dépannage informatique pour les entreprises ${v.a} : surveillance 24h/24, dépannage à distance immédiat, intervention sous 4 h ouvrées. Un seul interlocuteur.`,
  kicker: `Informatique d'entreprise · ${v.nom}`,
  title: "Vos postes surveillés en permanence. Vos pannes réglées à distance, tout de suite.",
  intro: v.intro,
  sections: [
    { heading: v.localHeading, paragraphs: v.localParagraphs },
    commentNousTravaillons(v),
    {
      heading: "Où nous intervenons",
      paragraphs: [
        `Nous accompagnons les entreprises ${v.a} et dans les communes voisines : ${v.voisines.join(", ")}. Et plus largement, dans toute la métropole lilloise et les Hauts-de-France.`,
        "Comme la quasi-totalité des interventions se fait à distance, la distance ne change rien à la rapidité du dépannage.",
      ],
    },
    liensUtiles,
  ],
  faq: [
    v.faqLocal,
    {
      q: `Vous n'êtes pas basés ${v.a}. Est-ce un problème ?`,
      a: "Non. Nos bureaux sont à Lille, mais la plupart des pannes se règlent à distance, en quelques minutes : c'est plus rapide que d'attendre le passage d'un technicien. Quand une présence est indispensable, nous nous déplaçons.",
    },
    {
      q: "Faut-il être client pour être dépanné ?",
      a: "Non, nous dépannons aussi les entreprises qui ne sont pas sous contrat, pour une intervention ponctuelle. Pour nos clients, le dépannage est compris dans l'abonnement.",
    },
    {
      q: "Y a-t-il un engagement ?",
      a: "Oui, le contrat de maintenance est conclu pour 3 ans. C'est ce qui nous permet de garantir un prix fixe, tout compris, et d'investir dès le départ dans la mise en place et la sécurisation de votre informatique.",
    },
  ],
});

export const VILLE_ORDER = Object.keys(VILLES);
for (const slug of VILLE_ORDER) {
  LOCAL_PAGES[`informatique-entreprise-${slug}`] = villePage(VILLES[slug]);
}

// Page régionale qui regroupe les villes (liens internes vers chaque page ville).
LOCAL_PAGES["informatique-hauts-de-france"] = {
  navLabel: "Informatique dans les Hauts-de-France",
  serviceType: "Maintenance et dépannage informatique",
  areaServed: { "@type": "AdministrativeArea", name: "Hauts-de-France" },
  footer: true,
  phoneCta: true,
  seoTitle: "Maintenance et dépannage informatique dans les Hauts-de-France",
  seoDescription:
    "Maintenance et dépannage informatique pour les TPE de toute la région Hauts-de-France : surveillance 24h/24, dépannage à distance immédiat, un seul interlocuteur basé à Lille.",
  kicker: "Hauts-de-France",
  title: "Où que soit votre entreprise dans la région, nous intervenons tout de suite.",
  intro:
    "Umbo, basé à Lille, assure la maintenance et le dépannage informatique des petites entreprises de toute la région Hauts-de-France. Vos postes sont surveillés en permanence, et la plupart des pannes se règlent à distance, en quelques minutes.",
  sections: [
    {
      heading: "La distance ne compte plus",
      paragraphs: [
        "Pendant longtemps, choisir un prestataire informatique, c'était choisir le plus proche, pour qu'il puisse passer vite. Aujourd'hui, la plupart des pannes se règlent à distance, et plus vite qu'avec un déplacement.",
        "Nos outils surveillent vos postes en continu et nous alertent avant la panne. Quand vous appelez, nous prenons la main à distance avec votre accord. Et quand une présence est vraiment indispensable, nous nous déplaçons.",
      ],
    },
    {
      heading: "Métropole lilloise",
      links: [
        { to: "/maintenance-informatique-lille", label: "Lille" },
        ...VILLE_ORDER.map((slug) => ({ to: `/informatique-entreprise-${slug}`, label: VILLES[slug].nom })),
      ],
    },
    {
      heading: "Et partout dans la région",
      paragraphs: [
        "Nous accompagnons aussi les entreprises du Nord, du Pas-de-Calais, de la Somme, de l'Oise et de l'Aisne : Arras, Douai, Valenciennes, Lens, Béthune, Dunkerque, Calais, Boulogne-sur-Mer, Amiens, Saint-Quentin, Beauvais, Compiègne et ailleurs.",
      ],
    },
  ],
  faq: [
    {
      q: "Comment pouvez-vous dépanner une entreprise loin de Lille ?",
      a: "La quasi-totalité des pannes se règle à distance : nous prenons la main sur l'ordinateur concerné, avec votre accord. Et comme vos postes sont surveillés en permanence, beaucoup de problèmes sont traités avant même que vous ne les remarquiez.",
    },
    {
      q: "Et si une intervention sur place est nécessaire ?",
      a: "Nous nous déplaçons quand une présence est indispensable, par exemple pour remplacer du matériel. Deux interventions sur site sont incluses chaque année dans nos contrats.",
    },
    {
      q: "Faut-il être client pour être dépanné ?",
      a: "Non, nous dépannons aussi les entreprises qui ne sont pas sous contrat, pour une intervention ponctuelle.",
    },
  ],
};

// Pages Lille + page régionale dans le pied de page (pas les pages villes, pour ne pas l'alourdir).
LOCAL_PAGES["depannage-informatique-lille"].footer = true;
LOCAL_PAGES["maintenance-informatique-lille"].footer = true;

export const LOCAL_ORDER = [
  "depannage-informatique-lille",
  "maintenance-informatique-lille",
  "informatique-hauts-de-france",
  ...VILLE_ORDER.map((slug) => `informatique-entreprise-${slug}`),
];
